import { render, staticRenderFns } from "./goldPrint.vue?vue&type=template&id=f96a5270&"
import script from "./goldPrint.vue?vue&type=script&lang=js&"
export * from "./goldPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports